<mat-expansion-panel [formGroup]="form">
  <mat-expansion-panel-header>Søgning og periode</mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Index opdatering</dt>
        <dd>{{value.schedule}}</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="45" class="settings-list">
        <dt>Periode interval for ansøgningsliste</dt>
        <dd>{{value.project_list_period}}</dd>
      </dl>
    </div>
  }
  @if (form.enabled) {
    <mat-form-field class="mr-3">
      <mat-label>Index opdatering</mat-label>
      <input
        matInput
        type="number"
        formControlName="schedule"
        />
      <mat-hint>Hvor ofte skal søgnings index opdateres, i timer.</mat-hint>
    </mat-form-field>

    <mat-form-field>
    <mat-label>Periode interval for ansøgningsliste</mat-label>
    <input
      matInput
      type="number"
      formControlName="project_list_period"
    />
    <mat-hint>Hvor mange måneder ansøgningsliste vises ud fra. Default er 6</mat-hint>
    </mat-form-field>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="edit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="cancel()">Fortryd</button>
        <button mat-flat-button (click)="save()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
